/**
 * 仓储管理--》出库单管理
 */

export default {
  // 出库单详情 文案替换 经办人 => 点数人
  detail_madeby_replace_points_person: ['99801','82635'], // 202511241142130904865
}
